import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import "react-phone-input-2/lib/style.css";
import { callApi } from '../../services/ApiServices';
import { Eye, EyeOff } from 'lucide-react';
import toast from 'react-hot-toast';


const ProfileManagement = ({ onClose , profileData,fetchProfile}) => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: 'benjamin.york@drs.com',
    phone: '',
    phoneCode: '',
    role: 'Administrator',
    department: 'Operations',
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const[errors, setErrors] = useState({})
  const [isLoading, setIsLoading] = useState(false);
  const[showPassword, setShowPassword] = useState(false);
  const[showConfirmPassword, setShowConfirmPassword] = useState(false);
  const[ShowCurrentPassword, setShowCurrentPassword] = useState(false);
  const[passLoading, setPassLoading] = useState(false);
  const [originalProfile, setOriginalProfile] = useState(null);

useEffect(() => {
  if (profileData) {
    setOriginalProfile(profileData);
  let phone = profileData.phoneNumber || "";

    // ✅ If phone exists and does NOT start with +, add +
    if (phone && !phone.startsWith("+")) {
      phone = "+" + phone;
    }
    setFormData(prev => ({
      ...prev,
      fullName: profileData.name || "",
      email: profileData.email || "",
      phone: phone,
      phoneCode: profileData.phoneCode || "",
    }));
  }
}, [profileData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setErrors((prev)=>({
      ...prev,
      [name]: ""
    }))
  };



   const validate = () => {
    let newErrors = {};

  //    if (!formData.fullName?.trim()) {
  //   newErrors.fullName = "Full name is required";
  // }

    if (!formData?.email) {
      newErrors.email = "Email is required";
    } else if (
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      newErrors.email = "Invalid email format";
    }

     const phone = formData.phone?.trim() || "";
  if (phone) {
    if (!/^\+?\d+$/.test(phone)) {
      newErrors.phone = "Phone must contain only digits";
    } else if (phone.length < 6 || phone.length > 15) {
      newErrors.phone = "Phone number must be between 6 and 15 digits";
    }
  }


    if (formData.newPassword?.trim().length>0) {
      if (formData.newPassword.length < 6) {
        newErrors.newPassword = "Password must be at least 6 characters";
      }
    }
    if(formData.confirmPassword?.trim().length>0){
      if (formData.newPassword !== formData.confirmPassword) {
        newErrors.confirmPassword = "Passwords do not match";
      }
      
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const validatePassword = () => {
  let newErrors = {};

  const currentPassword = formData.currentPassword?.trim() || "";
  const newPassword = formData.newPassword?.trim() || "";
  const confirmPassword = formData.confirmPassword?.trim() || "";

  // Current password required
  if (!currentPassword) {
    newErrors.currentPassword = "Current password is required";
  }

  // New password required
  if (!newPassword) {
    newErrors.newPassword = "New password is required";
  } else if (newPassword.length < 6) {
    newErrors.newPassword = "Password must be at least 6 characters";
  }

  // Confirm password required
  if (!confirmPassword) {
    newErrors.confirmPassword = "Confirm password is required";
  } else if (newPassword !== confirmPassword) {
    newErrors.confirmPassword = "Passwords do not match";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


  const onProfileSave = async()=>{
    if(!validate()) return ;
    const isNameChanged =
    formData.fullName?.trim() !== originalProfile?.name;
const normalizePhone = (phone) => {
  if (!phone) return "";
  return phone.replace(/^\+/, ""); // remove + before compare
};
  // const isPhoneChanged =
  //   formData.phone !== originalProfile?.phoneNumber ||
  //   formData.phoneCode !== originalProfile?.phoneCode;
 
const isPhoneChanged = normalizePhone(formData.phone) !== normalizePhone(originalProfile?.phoneNumber);
  if (!isNameChanged && !isPhoneChanged) {
    onClose()
    return; 
  }
    try {
      setIsLoading(true)
      const response = await callApi({
        method:"post",
        url:"admin/update/profile",
        data:{
            name : formData.fullName,
            phoneNumber : formData.phone,
           
        }
      })
      console.log("profile update", response)
      if(response.status==201){
        toast.success(response?.data?.message || "profile updated successfully", { id: "profileUpdateToast"} )
        fetchProfile()
        onClose()
      }
    } catch (error) {
      console.log("profile save error", error)
    }finally{
      setIsLoading(false)
    }
  }


    const onPasswordChange = async()=>{
    if(!validatePassword()) return ;
    try {
      setPassLoading(true)
      const response = await callApi({
        method:"post",
        url:"users/password/change",
        data:{
          currentPassword : formData.currentPassword,
          newPassword : formData.newPassword,
        }
      })
      console.log("change password ", response)
      if(response.status==201){
        toast.success(response?.data?.message || "password updated successfully", {id:"changePasswordToast"} )
        fetchProfile()
        onClose()
      }
    } catch (error) {
      console.log("change passwod  error", error)
    }finally{
      setPassLoading(false)
    }
  }


  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-[0px_0px_4px_#6d6d6d4a] w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-lg">
          <h2 className="text-2xl font-semibold text-black">
            Profile Management
          </h2>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              className="text-textcolor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6">
          {/* Profile Picture Section */}
          {/* <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 pb-6 border-b border-gray-200">
            <div className="w-24 h-24 rounded-full bg-primary flex items-center justify-center flex-shrink-0">
              <span className="text-3xl font-bold text-white">BY</span>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-semibold text-black mb-2">Profile Picture</h3>
              <p className="text-sm text-textcolor mb-3">
                Upload a new profile picture or keep the default initials
              </p>
              <div className="flex flex-wrap gap-3">
                <button className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-hover transition-colors text-sm font-medium">
                  Upload Photo
                </button>
                <button className="px-4 py-2 border border-gray-300 text-textcolor rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium">
                  Remove
                </button>
              </div>
            </div>
          </div> */}

          {/* Personal Information */}
          <div>
            <h3 className="text-xl font-semibold text-black mb-4 pb-3 border-b border-gray-200">
              Personal Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Full Name */}
              <div className="flex flex-col gap-2">
                <label className="text-base font-medium text-textcolor">
                  Full Name
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  maxLength={40}
                  placeholder="Enter full name"
                  onChange={handleChange}
                  className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
                />
                {errors && errors.fullName && (
                  <p className="text-red-500">{errors.fullName}</p>
                )}
              </div>

              {/* Email */}
              <div className="flex flex-col gap-2">
                <label className="text-base font-medium text-textcolor">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  maxLength={40}
                  disabled
                  className="px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg text-textcolor font-normal text-base cursor-not-allowed"
                />
                {errors && errors.email && (
                  <p className="text-red-500">{errors.email}</p>
                )}
              </div>

              {/* Phone */}
              <div className="flex flex-col gap-2">
                <label className="text-base font-medium text-textcolor">
                  Phone Number{" "}
                  <span className="text-gray-400 text-sm">
                    (with phone code)
                  </span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Enter phone number"
                  onWheel={(e) => e.target.blur()}
                  value={formData.phone}
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^\d+]/g, "");

                    if (value.includes("+")) {
                      value = "+" + value.replace(/\+/g, "").replace(/^\+/, "");
                    }

                    setFormData((prev) => ({
                      ...prev,
                      phone: value,
                    }));
                    setErrors((prev) => ({
                      ...prev,
                      phone: "",
                    }))
                  }
                }
                  className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
                />
                {/* <PhoneInput
                  country={"us"}
                  value={`${formData.phoneCode}${formData.phone}`}
                  countryCodeEditable={false}
                  onChange={(value, country) =>{


                    setFormData(prev => ({
                      ...prev,
                      phoneCode: `${country.dialCode}`,
                      phone: value.replace(country.dialCode, "")
                    }));
                  }}
                  inputClass="!w-full !h-[52px] !bg-[#fafafa] !border !border-gray-200 !rounded-lg !text-base"
                  containerClass="!w-full"
                  buttonClass="!border-gray-200"
                  inputProps={{
                    name: "phone",
                    required: true
                  }}
                  /> */}
                {errors && errors.phone && (
                  <p className="text-red-500 text-sm text-left">
                    {errors.phone}
                  </p>
                )}
              </div>

              {/* Role */}
              <div className="flex flex-col gap-2">
                <label className="text-base font-medium text-textcolor">
                  Role
                </label>
                <input
                  type="text"
                  name="role"
                  value={formData.role}
                  disabled
                  className="px-4 py-3 bg-gray-100 border border-gray-200 rounded-lg text-textcolor font-normal text-base cursor-not-allowed"
                />
              </div>

              {/* Department */}
              {/* <div className="flex flex-col gap-2 md:col-span-2">
                <label className="text-base font-medium text-textcolor">
                  Department
                </label>
                <input
                  type="text"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20"
                />
              </div> */}
            </div>
          </div>
          <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex flex-col sm:flex-row justify-end gap-3 rounded-b-lg">
            <button
              onClick={onClose}
              className="px-6 py-2.5 border border-gray-300 text-textcolor rounded-lg hover:bg-gray-50 transition-colors text-base font-medium order-2 sm:order-1"
            >
              Cancel
            </button>
            <button
              disabled={isLoading}
              className="px-6 py-2.5 bg-primary text-white rounded-lg hover:bg-hover transition-colors text-base font-medium order-1 sm:order-2"
              onClick={onProfileSave}
            >
              {isLoading ? (
                <span className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              ) : (
                "Save Changes"
              )}
            </button>
          </div>

          {/* Change Password */}
          <div>
            <h3 className="text-xl font-semibold text-black mb-4 pb-3 border-b border-gray-200">
              Change Password
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Current Password */}
              <div className="flex flex-col gap-2 md:col-span-2 relative">
                <label className="text-base font-medium text-textcolor">
                  Current Password
                </label>
                <input
                  type={ShowCurrentPassword ? "text" : "password"}
                  name="currentPassword"
                  value={formData.currentPassword}
                  onChange={handleChange}
                  maxLength={40}
                  placeholder="Enter current password"
                  className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20 placeholder:text-gray-400"
                />
                <button
                  type="button"
                  onClick={() => setShowCurrentPassword(!ShowCurrentPassword)}
                  className="absolute right-4 top-2/3 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {ShowCurrentPassword ? (
                    <EyeOff size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </button>
                {errors && errors.currentPassword && (
                  <p className="text-red-500">{errors.currentPassword}</p>
                )}
              </div>

              {/* New Password */}
              <div className="flex flex-col gap-2 relative">
                <label className="text-base font-medium text-textcolor">
                  New Password
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  value={formData.newPassword}
                  onChange={handleChange}
                  maxLength={40}
                  placeholder="Enter new password"
                  className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20 placeholder:text-gray-400"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-2/3 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
                {errors && errors.newPassword && (
                  <p className="text-red-500 text-sm text-left">
                    {errors.newPassword}
                  </p>
                )}
              </div>

              {/* Confirm Password */}
              <div className="flex flex-col gap-2 relative">
                <label className="text-base font-medium text-textcolor">
                  Confirm New Password
                </label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  maxLength={40}
                  placeholder="Confirm new password"
                  className="px-4 py-3 bg-[#fafafa] border border-gray-200 rounded-lg text-black font-normal text-base focus:outline-none focus:ring-2 focus:ring-primary/20 placeholder:text-gray-400"
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  className="absolute right-4 top-2/3 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {showConfirmPassword ? (
                    <EyeOff size={20} />
                  ) : (
                    <Eye size={20} />
                  )}
                </button>
                {errors && errors.confirmPassword && (
                  <p className="text-red-500 text-sm text-left">
                    {errors.confirmPassword}
                  </p>
                )}
              </div>
            </div>
          </div>

          {/* Preferences */}
          <div>
            {/* <h3 className="text-xl font-semibold text-black mb-4 pb-3 border-b border-gray-200">
              Preferences
            </h3> */}
            <div className="space-y-4">
              {/* Email Notifications */}
              {/* <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-3">
                <div>
                  <h4 className="text-base font-medium text-black">Email Notifications</h4>
                  <p className="text-sm text-textcolor mt-1">
                    Receive email updates about your account activity
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
                  <input
                    type="checkbox"
                    defaultChecked
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-[#DEDEDE] rounded-full peer peer-checked:bg-[#4CAF50] peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div> */}

              {/* SMS Notifications */}
              {/* <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-3">
                <div>
                  <h4 className="text-base font-medium text-black">SMS Notifications</h4>
                  <p className="text-sm text-textcolor mt-1">
                    Receive text message alerts for important updates
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-[#DEDEDE] rounded-full peer peer-checked:bg-[#4CAF50] peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div> */}

              {/* Marketing Emails */}
              {/* <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-3">
                <div>
                  <h4 className="text-base font-medium text-black">Marketing Emails</h4>
                  <p className="text-sm text-textcolor mt-1">
                    Receive promotional content and special offers
                  </p>
                </div>
                <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
                  <input
                    type="checkbox"
                    defaultChecked
                    className="sr-only peer"
                  />
                  <div className="w-11 h-6 bg-[#DEDEDE] rounded-full peer peer-checked:bg-[#4CAF50] peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
                </label>
              </div> */}
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex flex-col sm:flex-row justify-end gap-3 rounded-b-lg">
          <button
            onClick={onClose}
            className="px-6 py-2.5 border border-gray-300 text-textcolor rounded-lg hover:bg-gray-50 transition-colors text-base font-medium order-2 sm:order-1"
          >
            Cancel
          </button>
          <button
            className="px-6 py-2.5 bg-primary text-white rounded-lg hover:bg-hover transition-colors text-base font-medium order-1 sm:order-2"
            onClick={onPasswordChange}
            disabled={passLoading}
          >
            {passLoading ? (
              <span className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileManagement;
